<script lang="ts" setup>
  import { InformationCircleIcon } from '@heroicons/vue/solid';
  import AsteriskText from '~/components/shared/Forms/AsteriskText.vue';

  const props = defineProps<{
    value: string | boolean | null;
    labelText: string;
    name: string;
    stateKey: string;
    radioOptions: { label: string; value: string | boolean }[];
    isDisabled?: boolean;
    rules?: any;
    labelClass?: string;
    inputClass?: string;
    isCompulsory?: boolean;
    eyeButtonText?: string;
    labelCol?: object;
  }>();

  const localValue = ref<string | boolean | null>(props.value);

  const emit = defineEmits(['update:value']);

  watch(
    () => props.value,
    newValue => {
      localValue.value = newValue;
    }
  );

  watch(
    () => localValue.value,
    newValue => {
      emit('update:value', newValue, props.stateKey);
    }
  );
</script>
<template>
  <a-form-item class="!font-medium mb-0" :rules="props.rules" :name="props.name" :label-col="props.labelCol">
    <!-- LABEL SLOT -->
    <template #label>
      <div class="flex items-center gap-1">
        <div>
          <AsteriskText v-if="isCompulsory" :label="labelText" />
          <p v-else class="text-zinc-600">{{ props.labelText }}</p>
        </div>
        <div>
          <a-tooltip
            v-if="eyeButtonText"
            overlay-class-name="text-xs"
            color="#3F3F46"
            :arrow="false"
            placement="bottom"
          >
            <template #title>
              <div v-html="eyeButtonText"></div>
            </template>

            <InformationCircleIcon class="h-4 w-4 text-zinc-500 cursor-pointer" />
          </a-tooltip>
        </div>

        <!-- Tooltip Icon -->
      </div>
    </template>

    <!-- RADIO GROUP (appears on new row) -->
    <a-radio-group v-model:value="localValue" :disabled="props.isDisabled">
      <a-radio v-for="option in props.radioOptions" :key="option.value" :value="option.value">
        {{ option.label }}
      </a-radio>
    </a-radio-group>
  </a-form-item>
</template>
